document.addEventListener('DOMContentLoaded', function () {
    const page = document.querySelector('.page-template-template-problems');
    if (!page) return;

    const grid = page.querySelector('.hero-container__items');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.js-problem-item'));
    if (!items.length) return;

    let activeItem = null;

    const getColumnsCount = () => {
        const styles = window.getComputedStyle(grid);
        const templateColumns = styles.getPropertyValue('grid-template-columns');
        if (!templateColumns) return 1;
        return templateColumns.split(' ').filter(Boolean).length || 1;
    };

    // zapamiętaj, w której kolumnie startowo siedzi każdy item (dla 3 kolumn)
    const initialCols = getColumnsCount();
    items.forEach((item, index) => {
        const colIndex = (index % initialCols) + 1; // 1-based
        item.dataset.gridColumn = String(colIndex);
    });

    const setToggleLabel = (item, isOpen) => {
        const toggle = item.querySelector('.problem-item__toggle');
        if (!toggle) return;
        const label = toggle.querySelector('.problem-item__toggle-text');
        if (!label) return;
        label.textContent = isOpen ? 'Zwiń' : 'Czytaj więcej';
    };

    const collapseItem = (item) => {
        const content = item.querySelector('.problem-item__content');
        if (!content) return;
        content.style.maxHeight = content.scrollHeight + 'px';
        // force reflow for transition
        // eslint-disable-next-line no-unused-expressions
        content.offsetHeight;
        content.style.maxHeight = '0px';
        item.classList.remove('is-active');
        item.style.gridRowStart = '';
        item.style.gridRowEnd = '';
        item.style.gridColumn = '';
        setToggleLabel(item, false);
    };

    const expandItem = (item) => {
        const content = item.querySelector('.problem-item__content');
        if (!content) return;
        const cols = getColumnsCount();
        const totalItems = items.length;
        const baseRows = Math.ceil(totalItems / cols) || 1;
        // po rozwinięciu powstaje jeszcze jeden wiersz, więc span = baseRows + 1
        const spanRows = baseRows + 1;

        // wrzuć na pierwszy wiersz w swojej pierwotnej kolumnie
        const colStart = item.dataset.gridColumn ? parseInt(item.dataset.gridColumn, 10) || 1 : 1;
        item.style.gridColumn = String(colStart);
        item.style.gridRow = '1 / span ' + spanRows;

        item.classList.add('is-active');
        content.style.maxHeight = content.scrollHeight + 'px';
        setToggleLabel(item, true);
    };

    const openItem = (item, scroll = true) => {
        if (activeItem && activeItem !== item) {
            collapseItem(activeItem);
            activeItem = null;
        }

        const isActive = item.classList.contains('is-active');

        if (isActive) {
            collapseItem(item);
            activeItem = null;
        } else {
            expandItem(item);
            activeItem = item;

            if (scroll) {
                item.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    };

    // Init collapsed state + click handlers
    items.forEach((item) => {
        const content = item.querySelector('.problem-item__content');
        if (content) {
            content.style.maxHeight = '0px';
        }

        const toggles = Array.from(item.querySelectorAll('.js-problem-toggle'));
        if (!toggles.length) return;

        toggles.forEach((toggle) => {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                openItem(item, true);
            });
        });
    });

    // Otwieranie konkretnego problemu z parametru w URL: ?problem=ID lub ?problem=slug
    const params = new URLSearchParams(window.location.search);
    const problemParam = params.get('problem');
    if (problemParam) {
        let targetItem = null;

        if (/^\d+$/.test(problemParam)) {
            // szukaj po ID
            targetItem = items.find((item) => item.dataset.problemId === problemParam);
        }

        if (!targetItem) {
            // fallback: szukaj po slugu
            targetItem = items.find((item) => item.dataset.problemSlug === problemParam);
        }

        if (targetItem) {
            // otwórz bez podwójnego scrolla na starcie
            openItem(targetItem, true);
        }
    }
});
